<template>
    <div class="version1-left-top-header">
        <div class="version1-left-top-text">
            <span>{{ title }}</span>
            <img src="../../../../../static/version1/标题箭头右.png" alt="">
        </div>
        <img src="../../../../../static/version1/右边板块标题样式.png" alt="" class="line">
    </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {

    }
  }
}
</script>
